export default __webpack_public_path__ + "static/media/video.96992c44.mp4";